// @flow
import React from 'react';
import SearchFields from '../SearchFields/SearchFields';
import {compose} from 'redux';
import {connect} from 'react-redux';
import routerActions from '../../actions/router';

import './ExpandedSearchBar.less';

type DispatchProps = {
    search: typeof routerActions.search,
    locationSearch: typeof routerActions.locationSearch
};

type Props = DispatchProps;

export const ExpandedSearchBar = ({search, locationSearch}: Props) => (
    <div className="ExpandedSearchBar" data-wdio="ExpandedSearchBar">
        <SearchFields
            onChange={search}
            onLocationChange={locationSearch}
            datepickerConfig={{
                useFloatingLabel: false
            }}
        />
    </div>
);

const mapDispatchToProps = {
    search: routerActions.search,
    locationSearch: routerActions.locationSearch
};

export default compose(connect(null, mapDispatchToProps))(ExpandedSearchBar);
